const METHODS_ORDER = {
  SAME_DAY: 1,
  NEXT_DAY: 2,
  SCHEDULED: 3,
  DATE_RANGE: 4,
  SCHEDULED_DEFERRED: 0
};

export default METHODS_ORDER;
